import callApi from "./index";
import URL_API from "../constants/urlPaths";

export default {
  login(data) {
    return callApi.request({
      method: "POST",
      url: URL_API.LOG_IN,
      data,
    });
  },

  registration(data) {
    return callApi.request({
      method: "POST",
      url: URL_API.REGISTRATION,
      data,
    });
  },

  getRegistrationField() {
    return callApi.request({
      method: "GET",
      url: URL_API.REGISTRATION,
    });
  },

  getProfile() {
    return callApi.request({
      method: "POST",
      url: URL_API.GET_PROFILE,
    });
  },

  logout() {
    return callApi.request({
      method: "POST",
      url: URL_API.LOG_OUT,
    });
  },

  getUsersList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: URL_API.USER + url,
      })
      .then((res) => res.data);
  },

  setUsersVars(data) {
    return callApi
      .request({
        method: "POST",
        url: URL_API.USER_VARS,
        data,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  getUsersVars(url = "") {
    return callApi
      .request({
        method: "GET",
        url: URL_API.USER_VARS + url,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  getUsersAllList() {
    return callApi
      .request({
        method: "GET",
        url: URL_API.USER_ALL,
      })
      .then((res) => res.data);
  },

  getUsersListFilter(url = "", data) {
    return callApi
      .request({
        method: "POST",
        url: URL_API.USER_FILTER + url,
        data,
      })
      .then((res) => res.data);
  },

  createUser(data) {
    return callApi
      .request({
        method: "POST",
        url: URL_API.USER,
        data,
      })
      .then((res) => res.data);
  },

  editUser(url, data) {
    return callApi
      .request({
        method: "PUT",
        url: URL_API.USER + url,
        data,
      })
      .then((res) => res.data);
  },

  editUserFb(url, data) {
    return callApi
      .request({
        method: "PUT",
        url: URL_API.USER + "/facebook-id" + url,
        data,
      })
      .then((res) => res.data);
  },

  getItemUser(url) {
    return callApi
      .request({
        method: "GET",
        url: URL_API.USER + url,
      })
      .then((res) => res.data);
  },

  deleteUser(url) {
    return callApi
      .request({
        method: "DELETE",
        url: URL_API.USER + url,
      })
      .then((res) => res.data);
  },

  getUserGroupList() {
    return callApi
      .request({
        method: "GET",
        url: URL_API.USER_GROUP + "?exceptBuyer=1",
      })
      .then((res) => res.data);
  },

  getTeamList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: URL_API.TEAM + url,
      })
      .then((res) => res.data);
  },

  getTeamListFilter(url = "", data) {
    return callApi
      .request({
        method: "POST",
        url: URL_API.TEAM_FILTER + url,
        data,
      })
      .then((res) => res.data);
  },

  createTeam(data) {
    return callApi
      .request({
        method: "POST",
        url: URL_API.TEAM,
        data,
      })
      .then((res) => res.data);
  },

  editTeam(url, data) {
    return callApi
      .request({
        method: "PUT",
        url: URL_API.TEAM + url,
        data,
      })
      .then((res) => res.data);
  },

  getItemTeam(url) {
    return callApi
      .request({
        method: "GET",
        url: URL_API.TEAM + url,
      })
      .then((res) => res.data);
  },

  deleteTeam(url) {
    return callApi
      .request({
        method: "DELETE",
        url: URL_API.TEAM + url,
      })
      .then((res) => res.data);
  },

  getUserTeamList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: URL_API.TEAM_USER + url,
      })
      .then((res) => res.data);
  },

  getUserTeamListFilter(url = "", data) {
    return callApi
      .request({
        method: "GET",
        url: URL_API.TEAM_USER_FILTER + url,
        data,
      })
      .then((res) => res.data);
  },

  deleteUserTeam(url = "") {
    return callApi
      .request({
        method: "DELETE",
        url: URL_API.TEAM_USER + url,
      })
      .then((res) => res.data);
  },

  getBayerAll() {
    return callApi
      .request({
        method: "GET",
        url: URL_API.GET_BUYER,
      })
      .then((res) => res.data);
  },

  getTeamAll() {
    return callApi
      .request({
        method: "GET",
        url: URL_API.TEAM_ALL,
      })
      .then((res) => res.data);
  },

  getSpendingList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: URL_API.SPENDING + url,
      })
      .then((res) => res.data);
  },

  getSpendingListFilter(url = "", data) {
    return callApi
      .request({
        method: "POST",
        url: URL_API.SPENDING + "/filter" + url,
        data,
      })
      .then((res) => res.data);
  },

  importSpending(data) {
    return callApi
      .request({
        headers: {
          "Content-Type": "multipart/form-data",
        },
        method: "POST",
        url: "/v1/analytics-spending/admin/import",
        data,
      })
      .then((res) => res.data);
  },

  exportSpending(data) {
    return callApi
      .request({
        method: "POST",
        url: "/v1/analytics-spending/admin/export",
        data,
      })
      .then((res) => res);
  },
  alertSpending(data) {
    return callApi
      .request({
        method: "POST",
        url: URL_API.SPENDING_ALERT,
        data,
      })
      .then((res) => res);
  },
};
